import styled from 'styled-components';
import { palette } from 'styled-tools';
import { BsSearch } from 'react-icons/bs';

export const Field = styled.label`
  width: fit-content;

  input {
    width: 20rem;
    padding-left: 30px;
  }
`;

export const SearchContainer = styled.div`
  width: fit-content;
  position: relative;
`;

export const SearchIcon = styled(BsSearch)`
  position: absolute;
  left: 2%;
  top: 30%;
  bottom: 50%;
  z-index: 3;
`;

export const CloseButton = styled.button`
  background-color: inherit;
  width: fit-content;
  height: fit-content;
  border: none;
  position: absolute;
  top: 23%;
  bottom: 50%;
  right: 2%;
  z-index: 3;
  cursor: pointer;
  padding: 0;

  svg {
    color: ${palette('colorBody')};
  }
`;
